export default "__VITE_ASSET__D0sxQ0ej__"